import { render, staticRenderFns } from "./module-administrator.vue?vue&type=template&id=2cc8dd53&scoped=true"
import script from "./module-administrator.vue?vue&type=script&lang=js"
export * from "./module-administrator.vue?vue&type=script&lang=js"
import style0 from "./module-administrator.vue?vue&type=style&index=0&id=2cc8dd53&prod&lang=scss&scoped=true"
import style1 from "./module-administrator.vue?vue&type=style&index=1&id=2cc8dd53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8dd53",
  null
  
)

export default component.exports